import { useEffect, useState } from 'react';
import { TopNav } from './sections/TopNav';
import { Hero } from './sections/Hero';
import { TrustStrip } from './sections/TrustStrip';
import { Testimonials } from './sections/Testimonials';
import { Services } from './sections/Services';
import { WhyAdspert } from './sections/WhyAdspert';
import { HowItWorks } from './sections/HowItWorks';
import { Faq } from './sections/Faq';
import { FinalCTA } from './sections/FinalCTA';
import { Footer } from './sections/Footer';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';

type Route = 'home' | 'privacy' | 'terms';

function resolveRoute(pathname: string): Route {
  if (pathname.startsWith('/privacy')) return 'privacy';
  if (pathname.startsWith('/terms')) return 'terms';
  return 'home';
}

export function App() {
  const [route, setRoute] = useState<Route>(() => resolveRoute(window.location.pathname));

  useEffect(() => {
    const onPop = () => setRoute(resolveRoute(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  return (
    <div className="min-h-screen bg-background text-ink">
      <TopNav />
      {route === 'home' ? (
        <main>
          <Hero />
          <TrustStrip />
          <Testimonials />
          <Services />
          <WhyAdspert />
          <HowItWorks />
          <Faq />
          <FinalCTA />
        </main>
      ) : route === 'privacy' ? (
        <main className="bg-surface">
          <PrivacyPage />
        </main>
      ) : (
        <main className="bg-surface">
          <TermsPage />
        </main>
      )}
      <Footer />
    </div>
  );
}
